"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OvertimePreviewResultDtoStatusEnum = void 0;
exports.instanceOfOvertimePreviewResultDto = instanceOfOvertimePreviewResultDto;
exports.OvertimePreviewResultDtoFromJSON = OvertimePreviewResultDtoFromJSON;
exports.OvertimePreviewResultDtoFromJSONTyped = OvertimePreviewResultDtoFromJSONTyped;
exports.OvertimePreviewResultDtoToJSON = OvertimePreviewResultDtoToJSON;
exports.OvertimePreviewResultDtoToJSONTyped = OvertimePreviewResultDtoToJSONTyped;
const OvertimePreviewItemDto_1 = require("./OvertimePreviewItemDto");
/**
 * @export
 */
exports.OvertimePreviewResultDtoStatusEnum = {
    Pending: 'PENDING',
    Done: 'DONE',
    Failed: 'FAILED'
};
/**
 * Check if a given object implements the OvertimePreviewResultDto interface.
 */
function instanceOfOvertimePreviewResultDto(value) {
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('items' in value) || value['items'] === undefined)
        return false;
    return true;
}
function OvertimePreviewResultDtoFromJSON(json) {
    return OvertimePreviewResultDtoFromJSONTyped(json, false);
}
function OvertimePreviewResultDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'status': json['status'],
        'items': (json['items'].map(OvertimePreviewItemDto_1.OvertimePreviewItemDtoFromJSON)),
    };
}
function OvertimePreviewResultDtoToJSON(json) {
    return OvertimePreviewResultDtoToJSONTyped(json, false);
}
function OvertimePreviewResultDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'status': value['status'],
        'items': (value['items'].map(OvertimePreviewItemDto_1.OvertimePreviewItemDtoToJSON)),
    };
}
//# sourceMappingURL=OvertimePreviewResultDto.js.map